import { gql } from '@apollo/client';

export default gql`
  query getLoyaltyBusinessAccountBenefits($membershipNumber: String!) {
    getLoyaltyBusinessAccountBenefits(membershipNumber: $membershipNumber) {
      businessId
      tripSummary {
        standardTrips
        plusTrips
        premiumTrips
      }
      benefitList {
        id
        benefitStatus
        benefitName
        benefitTypeName
        transactionJournal
        startDate
        endDate
        reasonForCancellation
        pnr
        benefitRedemptionDate
      }
    }
  }
`;
